import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';
import { message } from 'ant-design-vue';
import Login from '@/pages/Login.vue';
import Home from '@/pages/kevinHome.vue';
// import Dashboard from '@/pages/kevinDashboard.vue';
import UserList from '@/pages/UserList.vue';
import UserRole from '@/pages/UserRole.vue';
import UserProfile from '@/pages/UserProfile.vue';
import UnderDevelopment from '@/pages/UnderDevelopment.vue';
import PermissionMg from '@/pages/PermissionMg.vue'; 
import HttpLogMg from '@/pages/HttpLog.vue'; 
import OSLogMG from '@/pages/OSLog.vue';   
// 消息管理相关页面
import SystemAnnouncement from '@/pages/SystemAnnouncement.vue';
import MyMessages from '@/pages/MyMessages.vue';
import DicConfig from '@/pages/DicMg.vue';
// 代码生成器页面
import CodeGenerator from '@/pages/CodeGenerator.vue';
// AI管理相关页面
import AiAppsMg from '@/pages/ai/AgentManagement.vue';
import AiPromptsMg from '@/pages/ai/PromptManagement.vue';
import AiKmssMg from '@/pages/ai/KnowledgeBaseManagement.vue';
import AiModelMg from '@/pages/ai/ModelManagement.vue';
import AiSkillToolMg from '@/pages/ai/SkillToolManagement.vue';
import MyAIChat from '@/pages/ai/MyAIChat.vue';
import MyAITasks from '@/pages/ai/MyAITasks.vue';
import MyAgentList from '@/pages/ai/MyAgentList.vue';
//组织架构相关页面
import PositionManagement from '@/pages/organizational/PositionManagement.vue';
import DepartmentManagement from '@/pages/organizational/DepartmentManagement.vue';
// 租户管理页面
import TenantManagement from '@/pages/TenantManagement.vue';
// 法律应用门户页
import LegalPortal from '@/pages/LegalPortal.vue';
// 合同审查相关页面
import ContractReview from '@/pages/ContractReview/index.vue';
import ContractReviewRequirements from '@/pages/ContractReview/ReviewRequirements.vue';
import ContractReviewResult from '@/pages/ContractReview/ReviewResult.vue';
import ContractReviewList from '@/pages/ContractReview/ReviewList.vue';
// 裁判文书相关页面
import JudicativePaper from '@/pages/JudicativePaper/index.vue';
import JudicativePaperList from '@/pages/JudicativePaper/judicativeList.vue';
import JudicativePaperResult from '@/pages/JudicativePaper/judicativeResult.vue';
// 要素式文书相关页面
import ElementBased from '@/pages/ElementBased/index.vue';
import ElementBasedGenerateResults from '@/pages/ElementBased/generateResults.vue';
import ElementBasedGenerateList from '@/pages/ElementBased/generateList.vue';
// 法律检索
import SearchHome from '@/components/casesearch/SearchHome.vue';
// 我的收藏
import CollectIndex from '@/components/collect/CollectIndex.vue';
// 历史记录
import HistoryRecord from '@/pages/HistoryRecord.vue';

// 个人中心
import PersonalCenter from '@/pages/PersonalCenter/PersonalCenter.vue';

// vip套餐
import PurchasePlan from '@/pages/PurchasePlan/PurchasePlan.vue';
// 销售联系
import Contact from '@/pages/Contact.vue';

// 起诉状生成
import DocumentHome from '@/components/documenthome/DocumentHome.vue';

// 电话号码登录1
import PhoneLogin from '@/pages/PhoneLogin.vue';
// 电话号码登录2
import NumberLogin from '@/pages/Numberlogin.vue';
// 默认首页（免登录）
import DefaultHome from '@/pages/DefaultHome/index.vue';
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
   {
    path: '/PhoneLogin',
    name: 'PhoneLogin',
    component: PhoneLogin
  },
  {
    path: '/NumberLogin',
    name: 'NumberLogin',
    component: NumberLogin
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
    // 销售联系
      {
        path: '/Contact',
        name: 'Contact',
        component: Contact
      },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: DefaultHome
      },
      {
        path: 'user/list',
        name: 'UserList',
        component: UserList
      },
      {
        path: 'user/role',
        name: 'UserRole',
        component: UserRole
      },
      {
        path: 'user/profile',
        name: 'UserProfile',
        component: UserProfile
      },
      {
        path: 'user/permission',
        name: 'PermissionMg',
        component: PermissionMg
      },
      {
        path: 'system/dic',
        name: 'dicConfig',
        component: DicConfig
      },
      {
        path: 'system/log',
        name: 'HttpLogMg',
        component: HttpLogMg
      },
      {
        path: 'system/oslog',
        name: 'OSLogMG',
        component: OSLogMG
      },
      {
        path: 'system/announcement',
        name: 'SystemAnnouncement',
        component: SystemAnnouncement
      },
      {
        path: 'system/tenant',
        name: 'TenantManagement',
        component: TenantManagement
      },
      {
        path: 'system/code-generator',
        name: 'CodeGenerator',
        component: CodeGenerator
      },
      {
        path: 'my/message',
        name: 'MyMessages',
        component: MyMessages
      },
        {
        path: 'my/ai-chat',
        name: 'MyAIChat',
        component: MyAIChat
      },
      {
        path: 'my/ai-tasks',
        name: 'MyAITasks',
        component: MyAITasks
      },
      {
        path: 'my/ai-agents',
        name: 'MyAgentList',
        component: MyAgentList
      },
      {
        path: 'underdevelopment',
        name: 'UnderDevelopment',
        component: UnderDevelopment
      },
      // 类案检索
      {
        path: 'SearchHome',
        name: 'SearchHome',
        component: SearchHome
      },
      // 起诉状生成
      {
        path: 'DocumentHome',
        name: 'DocumentHome',
        component: DocumentHome
      },
      // 历史记录
      {
        path: 'HistoryRecord',
        name: 'HistoryRecord',
        component: HistoryRecord
      },
       // 我的收藏
      {
        path: 'CollectIndex',
        name: 'CollectIndex',
        component: CollectIndex
      },
       // 个人中心
      {
        path: 'PersonalCenter',
        name: 'PersonalCenter',
        component: PersonalCenter
      },
       // vip套餐
      {
        path: 'PurchasePlan',
        name: 'PurchasePlan',
        component: PurchasePlan
      },
      
      {
        path: 'aimanagement',
        name: 'aimanagement',
        component: UnderDevelopment
      },
        {
        path: 'aimanagement/aiappsmg',
        name: 'aiappsmg',
        component: AiAppsMg
      },
        {
        path: 'aimanagement/aipromptsmg',
        name: 'aipromptsmg',
        component: AiPromptsMg
      },
        {
        path: 'aimanagement/aikmssmg',
        name: 'aikmssmg',
        component: AiKmssMg // 替换为实际的知识库管理页面
      },
        {
        path: 'aimanagement/aimodelmg',
        name: 'aimodelmg',
        component: AiModelMg
      },
      {
        path: 'aimanagement/aiskilltoolmg',
        name: 'aiskilltoolmg',
        component: AiSkillToolMg
      },
      {
        path: 'position/management',
        name: 'positionManagement',
        component: PositionManagement
      }  ,{
        path: 'department/management',
        name: 'departmentManagement',
        component: DepartmentManagement
      },
      {
        path: 'legal/portal',
        name: 'LegalPortal',
        component: LegalPortal
      },
      // 合同审查
      {
        path: 'contract-review',
        name: 'ContractReview',
        component: ContractReview
      },
      // 合同审查-审查要求
      {
        path: 'contract-review/requirements',
        name: 'ContractReviewRequirements',
        component: ContractReviewRequirements
      },
      // 合同审查-审查结果
      {
        path: 'contract-review/result',
        name: 'ContractReviewResult',
        component: ContractReviewResult
      },
      // 合同审查-审查列表
      {
        path: 'contract-review/list',
        name: 'ContractReviewList',
        component: ContractReviewList
      },
      // 裁判文书
      {
        path: 'JudicativePaper',
        name: 'JudicativePaper',
        component: JudicativePaper
      },
      // 裁判文书-任务列表（查看全部）
      {
        path: 'JudicativePaper/list',
        name: 'JudicativePaperList',
        component: JudicativePaperList
      },
      // 裁判文书-生成结果
      {
        path: 'JudicativePaper/result',
        name: 'JudicativePaperResult',
        component: JudicativePaperResult
      },
      // 要素式文书
      {
        path: 'ElementBased',
        name: 'ElementBased',
        component: ElementBased
      },
      // 要素式文书-生成中/结果页
      {
        path: 'ElementBased/generateResults',
        name: 'ElementBasedGenerateResults',
        component: ElementBasedGenerateResults
      },
      // 要素式文书-生成记录列表（查看全部）
      {
        path: 'ElementBased/generateList',
        name: 'ElementBasedGenerateList',
        component: ElementBasedGenerateList
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由切换后把页面滚动回顶部。
// /home 布局的滚动容器是 .content-wrapper（非 window），导航后其 scrollTop 会保留，需手动归零。
// 仅路径变化时重置；query 变化（如页内筛选）保持当前滚动位置。
router.afterEach((to, from) => {
  // 百度统计：SPA 路由切换手动上报 PV。
  // 首次进入的 PV 由 index.html 里的统计脚本自动记录（from 为初始位置时跳过，避免重复）。
  if (from !== START_LOCATION) {
    window._hmt?.push?.(['_trackPageview', to.fullPath]);
  }
  if (to.path === from.path) return;
  const wrapper = document.querySelector('.content-wrapper');
  if (wrapper) wrapper.scrollTop = 0;
  window.scrollTo(0, 0);
});

// 路由守卫：直接刷新地址栏也生效
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  // 排除登录、联系我们页面，其余 /home 开头全部校验
  const publicPages = ['/NumberLogin','/PhoneLogin','/login','/Contact'];

  // 判断：不是公开页面，并且不是 /home 根路径（/home/xxx 子路由都会命中）
  if (!publicPages.includes(to.path) && to.path !== '/home') {
    if (!token) {
      message.warning('请先登录');
      next({
        path: '/NumberLogin',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    // /home、登录页、Contact页面直接放行
    next();
  }
});

export default router;